import { render, staticRenderFns } from "./PointBlockingModal.vue?vue&type=template&id=6dba5406&scoped=true"
import script from "./PointBlockingModal.vue?vue&type=script&lang=js"
export * from "./PointBlockingModal.vue?vue&type=script&lang=js"
import style0 from "./PointBlockingModal.vue?vue&type=style&index=0&id=6dba5406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba5406",
  null
  
)

export default component.exports